import React from 'react';

import clsx from 'clsx';

import { Stack, makeStyles } from '@gogame/components';
import { Breadcrumbs } from '@gogame/screens';

import {
  SearchPortal,
  PresetsPortal,
  AllFiltersPortal,
  FiltersApplyPortal,
  ActionsPortal,
  ActionPortal,
  BreadcrumbsPortal,
  PresetsContainer,
  FiltersContainer,
  FiltersApplyContainer,
  ActionsContainer,
  SmartSearchContainer,
  SmartSearchPortal,
} from './Portals';

const useStyles = makeStyles(
  (theme) => {
    return {
      root: {
        width: '100%',
        display: 'flex',
        maxHeight: '64px',
      },
      container: {
        width: '100%',
        display: 'flex',
        padding: '12px 16px',
        height: '64px',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      breadcrumbs: {
        minWidth: '0',
        color: theme.palette.text.primary,
      },
      right: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'nowrap',
      },
    };
  },
  { name: 'GgScreenToolbar' }
);

const ScreenToolbar = ({ className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} data-cy={'screenToolbar'}>
      <div className={classes.container}>
        <div className={classes.breadcrumbs}>
          <Breadcrumbs />
        </div>

        <div className={classes.right}>
          <SmartSearchContainer />
          <PresetsContainer />
          <Stack direction={'row'} spacing={2} alignItems={'center'}>
            <ActionsContainer />
            <FiltersContainer />
            <FiltersApplyContainer />
          </Stack>
        </div>
      </div>
    </div>
  );
};

ScreenToolbar.SearchField = SearchPortal;
ScreenToolbar.SmartSearchButton = SmartSearchPortal;
ScreenToolbar.Presets = PresetsPortal;
ScreenToolbar.Filters = () => {
  throw new Error(
    `use <Screen.Toolbar.AllFilters sidePage="AllFilters"> instead <Screen.Toolbar.Filters><AllFilters /></Screen.Toolbar.Filters>`
  );
};
ScreenToolbar.AllFilters = AllFiltersPortal;
ScreenToolbar.FiltersApply = FiltersApplyPortal;
ScreenToolbar.Actions = ActionsPortal;
ScreenToolbar.Action = ActionPortal;
ScreenToolbar.Breadcrumbs = BreadcrumbsPortal;
ScreenToolbar.ScreenActions = () => {
  throw new Error('SSRS screen action');
};

export default ScreenToolbar;
